<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <section id="page-title" style="background-color: #d1d1d1">
        <div class="row">
          <div class="col-sm-12">
            <h1 class="mainTitle">Verify OTP</h1>
          </div>
        </div>
      </section>
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <form @submit.prevent="handleVerify">
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  v-model="email"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>OTP</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="otp"
                  placeholder="Enter 4-digit code"
                />
              </div>
              <div class="form-group">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="loading"
                >
                  {{ loading ? "Verifying..." : "Verify" }}
                </button>
                <button
                  type="button"
                  class="btn btn-link"
                  @click="handleResend"
                  :disabled="resending || resendCooldown > 0"
                >
                  {{ resendLabel }}
                </button>
              </div>
              <div v-if="resendCooldown > 0" class="text-muted">
                Please wait 1 minute before requesting a new code.
              </div>
              <div v-if="errorMessage" class="alert alert-danger">
                {{ errorMessage }}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios, { setAuthorizationHeader } from "../../Axios";
import { store } from "../../Store";

export default {
  name: "VerifyOtp",
  data() {
    return {
      email: this.$route.query.email || "",
      otp: "",
      loading: false,
      resending: false,
      resendCooldown: 0,
      cooldownInterval: null,
      errorMessage: "",
    };
  },
  mounted() {
    // Start initial cooldown since OTP was just sent from login page
    this.startCooldown(60);
  },
  beforeUnmount() {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
      this.cooldownInterval = null;
    }
  },
  methods: {
    startCooldown(seconds) {
      if (this.cooldownInterval) {
        clearInterval(this.cooldownInterval);
        this.cooldownInterval = null;
      }
      this.resendCooldown = seconds;
      this.cooldownInterval = setInterval(() => {
        if (this.resendCooldown > 0) {
          this.resendCooldown -= 1;
        } else {
          clearInterval(this.cooldownInterval);
          this.cooldownInterval = null;
        }
      }, 1000);
    },
    async handleVerify() {
      try {
        this.loading = true;
        this.errorMessage = "";
        const response = await axios.post("/admin/auth/verify-otp", {
          email: this.email,
          otp: this.otp,
        });

        const token = response.data.token;
        const userData = response.data.user;

        if (token) {
          localStorage.setItem("access_token", token);
          setAuthorizationHeader(token);
        }

        // Derive role and permissions if present on user (fallbacks safe)
        const role =
          (userData.roles && userData.roles[0] && userData.roles[0].name) ||
          null;
        const permissions =
          (userData.roles && userData.roles[0] && userData.roles[0].permissions
            ? userData.roles[0].permissions.map((p) => p.name)
            : []) || [];

        store.setUserRole(role);
        store.setUserPermissions(permissions);
        store.setLoggedIn(true);
        store.setUser(userData);

        this.$router.push({ name: "home" });
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Verification failed";
      } finally {
        this.loading = false;
      }
    },
    async handleResend() {
      try {
        if (this.resendCooldown > 0) {
          return;
        }
        this.resending = true;
        this.errorMessage = "";
        await axios.post("/admin/auth/resend-otp", { email: this.email });
        this.startCooldown(60);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Could not resend OTP";
        // If backend says already sent, enforce 60s wait on UI
        if (String(message).toLowerCase().includes("already sent")) {
          this.startCooldown(60);
          this.errorMessage = "Please wait 1 minute and try again.";
        } else {
          this.errorMessage = message;
        }
      } finally {
        this.resending = false;
      }
    },
  },
  computed: {
    resendLabel() {
      if (this.resendCooldown > 0) {
        const seconds = String(this.resendCooldown).padStart(2, "0");
        return `Resend OTP (00:${seconds})`;
      }
      return this.resending ? "Resending..." : "Resend OTP";
    },
  },
};
</script>

<style scoped></style>
